import { render, staticRenderFns } from "./LineBreakColumn.vue?vue&type=template&id=04becc6f&scoped=true&"
import script from "./LineBreakColumn.vue?vue&type=script&lang=js&"
export * from "./LineBreakColumn.vue?vue&type=script&lang=js&"
import style0 from "./LineBreakColumn.vue?vue&type=style&index=0&id=04becc6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04becc6f",
  null
  
)

export default component.exports